module.exports = __webpack_public_path__ + "static/media/AG_NUTRITION_LOGO-02.4469ad18.png";